import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Lead, RefreshEmail } from 'Pages/partnerProfile'
import { Callback } from 'Src/types/utilTypes'
import { RequestParams, ShortDataModel } from 'Models'
import { AuthLoginModel } from 'Pages/auth'
import { AgreementModel } from 'Pages/admin'

export type LeadState = {
	lead: Lead | null
	errors: Object | null
	token: string | null
	dict_incorporation_form: ShortDataModel[] | null
	refresh_email: RefreshEmail
	realError: string | null
	refreshSms: boolean
	adAgreement: AgreementModel
}

const initialState: LeadState = {
	lead: null,
	errors: null,
	token: null,
	dict_incorporation_form: null,
	refresh_email: null,
	realError: null,
	refreshSms: false,
	adAgreement: null,
}

export namespace LeadNS {
	export type CrateLead = PayloadAction<{
		lead: Lead
		callback?: Callback
		errorCallback?: Callback
	}>
	export type GetTokenLead = PayloadAction<{
		token: string
		callback?: Callback
		errorCallback?: Callback
	}>
	export type ActivateLead = PayloadAction<{
		token: string
		lead: Lead | null
		callback?: Callback
		errorCallback?: Callback
	}>
	export type ValidateLead = PayloadAction<{
		token: string
		lead: Lead | null
		callback?: Callback
		errorCallback?: Callback
	}>
	export type CompleteLead = PayloadAction<{
		token: string
		lead: Lead | null
		callback?: Callback
		errorCallback?: Callback
	}>
	export type RefreshSmsLead = PayloadAction<{
		id: string | number
		callback?: Callback
		errorCallback?: Callback
	}>
	export type RefreshEmailLead = PayloadAction<{
		data: RefreshEmail
		callback?: Callback
		errorCallback?: Callback
	}>
	export type RecreateEmailLead = PayloadAction<{
		data: RefreshEmail
		callback?: Callback
		errorCallback?: Callback
	}>
	export type SetLead = PayloadAction<Lead>
	export type SetToken = PayloadAction<string>
	export type SetErrorsLead = PayloadAction<Object>
	export type ClearAll = PayloadAction
	export type GetDictIncorporationForm = PayloadAction
	export type SetDictIncorporationForm = PayloadAction<ShortDataModel[]>
	export type LoginUserLead = PayloadAction<AuthLoginModel>
	export type SetRefreshEmail = PayloadAction<RefreshEmail>
	export type SetRealErrorLead = PayloadAction<string>
	export type SetRefreshSms = PayloadAction<boolean>
	export type GetAdAgreement = PayloadAction<{
		params?: RequestParams
	}>
	export type SetAdAgreement = PayloadAction<AgreementModel>
}

export const leadSlice = createSlice({
	name: 'lead',
	initialState,
	reducers: {
		getDictIncorporationForm: (state, action: LeadNS.GetDictIncorporationForm) => {},
		setDictIncorporationForm: (state, action: LeadNS.SetDictIncorporationForm) => {
			state.dict_incorporation_form = action.payload
		},
		crateLead: (state, action: LeadNS.CrateLead) => {},
		getTokenLead: (state, action: LeadNS.GetTokenLead) => {},
		activateLead: (state, action: LeadNS.ActivateLead) => {},
		validateLead: (state, action: LeadNS.ValidateLead) => {},
		completeLead: (state, action: LeadNS.CompleteLead) => {},
		refreshSmsLead: (state, action: LeadNS.RefreshSmsLead) => {},
		refreshEmailLead: (state, action: LeadNS.RefreshEmailLead) => {},
		recreateEmailLead: (state, action: LeadNS.RecreateEmailLead) => {},
		loginUserLead: (state, action: LeadNS.LoginUserLead) => {},
		setLead: (state, action: LeadNS.SetLead) => {
			state.lead = action.payload
		},
		setToken: (state, action: LeadNS.SetToken) => {
			state.token = action.payload
		},
		setErrorsLead: (state, action: LeadNS.SetErrorsLead) => {
			state.errors = action.payload
		},
		clearAll: (state, action: LeadNS.ClearAll) => {
			state.errors = null
			state.lead = null
			state.token = null
		},
		setRefreshEmail: (state, action: LeadNS.SetRefreshEmail) => {
			state.refresh_email = action.payload
		},
		setRealErrorLead: (state, action: LeadNS.SetRealErrorLead) => {
			state.realError = action.payload
		},
		setRefreshSms: (state, action: LeadNS.SetRefreshSms) => {
			state.refreshSms = action.payload
		},
		getAdAgreement: (state, action: LeadNS.GetAdAgreement) => {},
		setAdAgreement: (state, action: LeadNS.SetAdAgreement) => {
			state.adAgreement = action.payload
		},
	},
})
